var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19.1322C21.9998 19.5071 21.9258 19.8784 21.7822 20.2247C21.6386 20.571 21.4281 20.8857 21.1629 21.1507C20.8976 21.4157 20.5828 21.6258 20.2363 21.7691C19.8898 21.9124 19.5185 21.986 19.1436 21.9858H4.8568C4.09959 21.9862 3.37324 21.6857 2.83751 21.1506C2.30178 20.6154 2.00053 19.8894 2 19.1322V4.8665C2.00063 4.10939 2.30195 3.38352 2.83768 2.84854C3.37341 2.31355 4.09969 2.01325 4.8568 2.01367H19.1436C19.5185 2.01341 19.8897 2.087 20.2362 2.23023C20.5826 2.37346 20.8974 2.58353 21.1627 2.84845C21.4279 3.11336 21.6384 3.42793 21.7821 3.77419C21.9257 4.12045 21.9998 4.49162 22 4.8665V19.1322Z",
    fill: "#FFE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2893 13.9974C16.1997 13.3013 15.8516 12.6643 15.3143 12.2127C15.2347 12.1427 15.1484 12.0775 15.053 12C15.1325 11.9403 15.1985 11.8946 15.2602 11.8433C15.647 11.5232 15.9457 11.1097 16.1283 10.642C16.3012 10.1997 16.356 9.72004 16.2873 9.25016C16.2113 8.67859 15.9587 8.14503 15.5648 7.72393C15.2841 7.41134 14.9373 7.16519 14.5496 7.00337C14.173 6.85091 13.77 6.77455 13.3637 6.77869H8.8113C8.77991 6.7769 8.74845 6.7769 8.71706 6.77869C8.66713 6.78096 8.62008 6.80273 8.58603 6.83931C8.55197 6.8759 8.53363 6.92438 8.53493 6.97434C8.53493 7.00615 8.53493 7.03757 8.53493 7.06898V16.9051C8.53493 16.9545 8.53214 17.0042 8.53493 17.0535C8.53697 17.0942 8.55318 17.133 8.58078 17.1631C8.60837 17.1931 8.64561 17.2126 8.68604 17.2181C8.7173 17.2219 8.74882 17.2231 8.78029 17.2217H13.495C13.9698 17.2235 14.4365 17.0988 14.847 16.8602C15.4336 16.5306 15.8863 16.0061 16.1267 15.3777C16.3002 14.9397 16.3563 14.4638 16.2893 13.9974ZM12.6662 14.3514H11.8156V9.65895H12.6567C12.6567 9.65895 12.6535 9.65657 12.6567 9.65657V9.65895H12.6662V14.3514Z",
    fill: "#1E1719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.9726,
    fill: "white",
    transform: "translate(2 2.01367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/카카오뱅크-24.6fcc5794da0e32c0bb9b5dd59acbeb5d.svg";
export { ForwardRef as ReactComponent };